<template>
  <div class="reports-index">

    <div class="reports-ul">

      <router-link
        :to="`/dashboard/reports/${report.route}`"
        v-for="(report, i) in reports"
        :key="i"
        v-if="available_reports[report.route] || report.isShow"
        class="reports-li"
      >
        {{ report.label }} <i class="fas fa-chevron-right"></i>
      </router-link>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import dayjs from 'dayjs';
import _ from 'lodash';

export default {
  name: 'Index',
  mounted() {
    const available_reports = this.$store.state.project.available_reports || {};

    if (this.available_reports) {
      this.available_reports = {
        ...this.available_reports,
        ...available_reports,
      };
    }
  },
  data() {
    return {
      available_reports: {
        JOB: true,
        TECH: true,
        PROF: true,
        COVID: true,
        WILD_PIPE: false,
        MATERIALS: false,
        MAIN: false,
        TASKS: true
      },
      reports: [
        {
          label: 'Общие отчеты по работам',
          route: 'MAIN',
        },
        {
          label: 'Общие отчеты с материалами',
          route: 'MATERIALS',
        },
        {
          label: 'Отчеты по работам',
          route: 'JOB',
        },
        {
          label: 'Отчеты по численности',
          route: 'PROF',
        },
        {
          label: 'Отчеты по технике',
          route: 'TECH',
        },
        {
          label: 'Отчет по сварке трубопроводов',
          route: 'WILD_PIPE',
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.reports-index {
  margin: 0 auto;
  max-width: 400px;
  padding-top: 20px;
}


.reports-ul {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .reports-li, > > > .reports-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 0 12px;
    text-decoration: none;
    color: #444;

    &.active {
      background: rgba(54, 118, 203, 0.26) !important;
    }

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Reports/Index.vue